module.exports = __webpack_public_path__ + "static/media/subscriptionFees.695a9edd.svg";